<template>

	<page>
		<title-view>מסך לקוחות
			<v-btn slot="actions" class="ml-2" color="primary" @click="onEdit({})">הוספת לקוח</v-btn>
		</title-view>
		<v-row>
			<v-col>
				<v-expansion-panels v-model="panel">
					<v-expansion-panel>
						<v-expansion-panel-header>
							<h3>סינון וייצוא טבלה</h3>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<clients-filter :v-model="filters" @input="getParams" />
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-col>
		</v-row>
		<row>
			<c-col>
				<clients-table :search="filters" @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת לקוח</span>
			<form-builder modelName="client" @save="openModal=false" module="ClientModule" :inputs="inputs"/>
		</popup-dialog>




	</page>


</template>

<script>
	import ClientsTable from "src/views/clients/ClientsTable";
	import ClientModule from "src/store/modules/Client.module";
	import FormBuilder from "../../components/form/FormBuilder";
	import ClientsFilter from "./ClientsFilter";

	export default {
		name: "clients-view",
		components: {ClientsFilter, FormBuilder, ClientsTable},
		data() {
			return {
				openModal: false,
				panel:false,
				filters:{},
				openExcel:false,
				inputs:
					[
						{label: "שם מלא", name: "name",},
						{label: "טלפון", name: "tel", type: "tel"},
						{label: "מספר זהות", name: "id_number"},
						{label: "דואר אלקטרוני", name: "email", type: "email"},
					]

			};
		},
		computed: {
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			}
		},
		methods: {
			onEdit(client) {
				this.$store.commit(ClientModule.types.GET, client);
				this.openModal = true;
			},
			exportExcel() {
				this.openExcel = true;
			},
			getParams(filters){
				this.filters = filters;
			}
		}

	};
</script>

<style scoped>

</style>
